var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"no-body":""}},[_c('b-row',_vm._l((_vm.settings),function(setting){return _c('b-col',{key:setting.title,class:{
        hidden: ['game.simpleplay'].includes(setting.key)
      },attrs:{"cols":"12","sm":"6"}},[_c('SettingComponent',{attrs:{"header-title":setting.title,"setting-key":setting.key}})],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }